/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Handover_Item_3Inputs */

const en_how_we_work_handover_item_3 = /** @type {(inputs: How_We_Work_Handover_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review and exception handling explained`)
};

const lv_how_we_work_handover_item_3 = /** @type {(inputs: How_We_Work_Handover_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izskaidrota pārskatīšana un rīcība ar izņēmumiem`)
};

/**
* | output |
* | --- |
* | "Review and exception handling explained" |
*
* @param {How_We_Work_Handover_Item_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_handover_item_3 = /** @type {((inputs?: How_We_Work_Handover_Item_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Handover_Item_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_handover_item_3(inputs)
	return en_how_we_work_handover_item_3(inputs)
});